export default __webpack_public_path__ + "static/media/Design_EngagementHubS3.0d1fab2c.png";